import React, { createContext, useContext, useState } from 'react';

// Create a context for PDF cache
const PdfCacheContext = createContext();

// Custom hook to use the PDF cache
export const usePdfCache = () => useContext(PdfCacheContext);

// Provider component
export const PdfCacheProvider = ({ children }) => {
  // Cache state: { url: dataUrl }
  const [pdfCache, setPdfCache] = useState({});

  // Add a rendered PDF to the cache
  const addToCache = (url, dataUrl) => {
    setPdfCache(prevCache => ({
      ...prevCache,
      [url]: dataUrl
    }));
  };

  // Get a PDF from the cache
  const getFromCache = (url) => {
    return pdfCache[url];
  };

  // Check if a PDF is in the cache
  const isInCache = (url) => {
    return !!pdfCache[url];
  };

  // Clear the cache
  const clearCache = () => {
    setPdfCache({});
  };

  // Value object to be provided by the context
  const value = {
    addToCache,
    getFromCache,
    isInCache,
    clearCache
  };

  return (
    <PdfCacheContext.Provider value={value}>
      {children}
    </PdfCacheContext.Provider>
  );
};
